import { BreadcrumbBar } from "../components/breadcrumbbar.js";
import hdsSkrimImg from "../images/hds-skrim.png";


export function GenericBanner(props) {
  let bannerStyleOverride = {};
  let contentStyleOverride = {};


  if (props.bannerImage) {
    bannerStyleOverride.backgroundImage = `url(${hdsSkrimImg}), url(${props.bannerImage})`;
  }
  if (props.shade) {
    bannerStyleOverride.backgroundColor = "rgba(0,0,0, .6)";
    bannerStyleOverride.backgroundBlendMode = "multiply";
  }
  if (props.articleContent) {
    contentStyleOverride.marginLeft = "24px";
    contentStyleOverride.paddingBottom = "10px";
  }

  return (
    <>
      {props.articleContent &&
        <div className={"genericBanner"} style={bannerStyleOverride}>
          <div style={contentStyleOverride}>
            {props.breadcrumbLevels &&
              <BreadcrumbBar levels={props.breadcrumbLevels} />}
            <div className={"genericBannerTitle"}>
              {props.title}
            </div>
            <div className={"genericBannerDescription"}>
              {props.tagline}
            </div>
          </div>
        </div>
      }
      {!props.articleContent &&
        <div className="genericBannerAlt" style={bannerStyleOverride}>
          <div className="genericBannerBodyAlt">
            {props.breadcrumbLevels &&
              <BreadcrumbBar levels={props.breadcrumbLevels} />}
            <div className={"genericBannerAltTitle"}>
              {props.title}
            </div>
            <div className={"genericBannerAltDescription"}>
              {props.tagline}
            </div>
          </div>
        </div>
      }
    </>
  );
}
